// extracted by mini-css-extract-plugin
export default {"flex-box":"index_flex-box__h7YXd","place-holder":"index_place-holder__8vyWU","shareViewWrapper":"index_shareViewWrapper__yLNjN","boardWrapper":"index_boardWrapper__-zqcV"};